import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { EMPTY_ARRAY, EMPTY_OBJECT, EVENT_TYPES, festiveEventsFacilities } from '../../constants/globalConstants'
import { globalKeyStore } from '../../redux/actions/globalState'
import Banner from '../../components/global/Banner'
import OffCanvas from '../../components/global/OffCanvas'
import BookingList from '../booking/BookingList'
import {
  //getEventDetails, 
  getFilteredEventList,
  // getMonthEventList,
  getPassDetails
} from '../../redux/actions/MainAction'
import { getConfigDetails } from '../../services/config'
import moment from 'moment'
import Loader from '../../components/global/Loader'
import MultipleEventCrousel from '../../components/global/MultipleEventCrousel'
import { useNavigate, useParams } from 'react-router-dom'
import Calender from '../../components/global/Calendar'
import { getConvertedDate } from '../../utils/helper'
import { getLowercaseValue } from './mainhelper'

const Main = ({ selectedPassType, dispatch, noOfEventShow, startDate, passDetails, loader, eventData, partnerDetails, selectedFacilityId, notify, selectedYearForLabel, isLoadingEvent, eventViewStyle }) => {
  // isCanvasShow
  const navigate = useNavigate()
  const [currMonthLoc, setCurrMonthLoc] = useState(null)
  const { partner, facility } = useParams()

  const [facilities, setFacilities] = useState(EMPTY_ARRAY)
  const firstLoad = useRef(0)

  useEffect(() => {
    const facilityList = facility ? partnerDetails?.facilities?.filter((item) => (item?.id == facility || item?.short_name?.toLowerCase() == getLowercaseValue(facility))) : partnerDetails?.facilities
    setFacilities(facilityList)
  }, [EMPTY_ARRAY])

  useEffect(() => {
    setTimeout(() => {
      const facilityList = facility ? partnerDetails?.facilities?.filter((item) => (item?.id == facility || item?.short_name?.toLowerCase() == getLowercaseValue(facility))) : partnerDetails?.facilities
      const selLocalFacilityId = facility ? facilityList?.[0]?.id : JSON.parse(localStorage?.getItem('selectedFacilityId'))

      if (selLocalFacilityId || selectedFacilityId) {
        const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
        dispatch(globalKeyStore({ selectedFacilityId: facility ? facilityList?.[0]?.id : eventFacilityid }))
        let curMonth = (moment().format('MMM-YYYY') == 'Oct-2025' && (festiveEventsFacilities?.includes(Number(facility))))
        handleFaciltyChange(eventFacilityid, '', '', false, true, curMonth ? '2025-11-01' : '')
      }
    }, 0)

    const listViewStyle = localStorage.getItem('eventViewStyle')
    if (listViewStyle == 'undefined' || listViewStyle == 'null' || listViewStyle == null) {
      dispatch(globalKeyStore({ eventViewStyle: 'list' }))
    } else {
      dispatch(globalKeyStore({ eventViewStyle: listViewStyle }))
    }



    // setTimeout(() => {
    //   // to filter the date of current month from api:-
    //   const currentSelDate = moment(startDate)?.format('MMM-YYYY')

    //   //api for pass Details 
    //   const passPayloads = { facility_id: getConfigDetails()?.FACILITY_ID }
    //   dispatch(getPassDetails(passPayloads))
    //   localStorage?.setItem('selectEventType', 'event')
    //   localStorage.removeItem('pass_type_slug')
    //   //api for Event Details 
    //   // const eventpayload = { event_type: EVENT_TYPES?.BUNDLE_PASS, facility_id: getConfigDetails()?.FACILITY_ID, pass_id: res?.data[1]?.id }
    //   const eventpayload = { event_type: EVENT_TYPES?.EVENT, facility_id: getConfigDetails()?.FACILITY_ID }

    //   if (eventpayload?.facility_id !== null) {
    //     dispatch(getEventDetails(eventpayload)).then((res) => {
    //       const filterEvents = res?.[currentSelDate] ? res?.[currentSelDate] : []
    //       dispatch(globalKeyStore({ selectedPassType: 0, eventData: filterEvents, selectEventType: 'event' }))
    //     })
    //   } else {
    //     navigate(0)
    //   }

    // }, 0)
  }, [])

  const handlePassManu = (id) => {
    const currentSelDate = moment(startDate)?.format('MMM-YYYY')
    const today = selectedYearForLabel ? moment(new Date(selectedYearForLabel))?.format('YYYY-MM-D') : moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss')))?.format('YYYY-MM-D')

    if (id && Number(id) > 0) {
      localStorage.setItem('selectEventType', 'pass')
      localStorage.removeItem('eventData')
    } else {
      localStorage.removeItem('passData')
      localStorage.setItem('selectEventType', 'event')
    }

    dispatch(globalKeyStore({ selectedPassType: Number(id) }))
    const localFacilityId = localStorage.getItem('selectedFacilityId')
    const eventpayload = {
      event_type: id ? EVENT_TYPES?.BUNDLE_PASS : EVENT_TYPES?.EVENT,
      facility_id: localFacilityId ? localFacilityId : getConfigDetails()?.FACILITY_ID,
      pass_id: id ? id : '',
      start_date: id == 0 ? moment(today).startOf('month').format('YYYY-MM-DD') : moment(today).format('YYYY-MM-DD'),
      end_date: moment(today).endOf('month').format('YYYY-MM-DD')
    }
    dispatch(globalKeyStore({ startValue: new Date(today) }))
    dispatch(getFilteredEventList(eventpayload)).then((res) => {
      if (res?.data) {
        if (eventpayload?.event_type == 'event') {
          localStorage?.setItem('selectEventType', 'event')
          localStorage.removeItem('pass_type_slug')
          const filterEvents = res?.data?.[currentSelDate] ? res?.data?.[currentSelDate] : []
          const EventsDates = res?.data?.eventsByMonth ? res?.data?.eventsByMonth : []
          dispatch(globalKeyStore({ selectedPassType: 0, allEventsData: filterEvents, eventData: filterEvents, selectEventType: 'event', selectedFacilityId: localFacilityId, calendarDates: EventsDates }))
        } else {
          localStorage.setItem('passData', JSON.stringify(res?.data))
          localStorage?.setItem('pass_type_slug', res?.data?.pass_type_slug)
          dispatch(globalKeyStore({ passData: res?.data, selectEventType: 'pass' }))
        }
        if(res?.data && !res?.data?.id && isNaN(eventpayload?.facility_id)) {
          navigate('/'+partner)
          navigate(0)
        }
        // localStorage.setItem('passData', JSON.stringify(res?.data))
      } else {
        if(facility) {
          navigate('/'+partner)
          navigate(0)
        }
        localStorage.setItem('passData', JSON.stringify({}))
      }
      // localStorage?.setItem('pass_type_slug', res?.data?.pass_type_slug)
      // dispatch(globalKeyStore({ selectedPassType: id, passData: res, selectEventType: 'pass' }))
    })
  }

  const loadMore = () => {
    dispatch(globalKeyStore({ noOfEventShow: noOfEventShow + noOfEventShow }))
  }

  // const handleOffCanvas = () => {
  //   dispatch(globalKeyStore({ isCanvasShow: !isCanvasShow }))
  // }


  const handleFaciltyChange = (value, currMonth = '', currYear = '', changeFac = false, firstVal = false, currentMonthFull = '') => {
    // const { value } = e.target
    // console.log(value)
    const localTimeZone = localStorage.getItem('facilitiesTimezone') || 'America/New_York'
    // to filter the date of current month from api:-
    const currentSelDate = (currMonth != '' && currMonth != '') ? moment().month(currMonth).year(currYear).format('MMM-YYYY') : moment(startDate)?.format('MMM-YYYY')
    const today = selectedYearForLabel ?
      moment(new Date(selectedYearForLabel))?.format('YYYY-MM-D') :
      moment().tz(`${localTimeZone}`)?.format('YYYY-MM-D')
    if (value && value > 0) {
      //api for pass Details 
      const passPayloads = { facility_id: value }
      dispatch(getPassDetails(passPayloads)).then((resp) => {
        let passDetails = []
        resp?.map((item) => {
          passDetails.push({ 'pass_id': item.id, 'facility_id': item.facility_id, 'is_pass_sold': item.is_pass_sold })
        })
        localStorage.setItem('passDetails', JSON.stringify(passDetails))
      })
      localStorage?.setItem('selectEventType', 'event')
      localStorage.removeItem('pass_type_slug')

      //  FOR LOCAL STATE 
      localStorage.setItem('selectedFacilityId', value)
      dispatch(globalKeyStore({ selectedFacilityId: value }))
      const filterData = partnerDetails?.facilities?.filter((item) => Number(item?.id) == Number(value))
      const start_date = (currentMonthFull) ? moment(currentMonthFull, 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD') : (selectedYearForLabel) ? moment(selectedYearForLabel, 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD') : moment().tz(filterData?.[0]?.timezone ? filterData?.[0]?.timezone : 'America/New_York').startOf('month').format('YYYY-MM-DD')
      const end_date = (currentMonthFull) ? moment(currentMonthFull, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD') : (selectedYearForLabel) ? moment(selectedYearForLabel, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD') : moment().tz(filterData?.[0]?.timezone ? filterData?.[0]?.timezone : 'America/New_York').endOf('month').format('YYYY-MM-DD')
      const eventpayload = {
        event_type: EVENT_TYPES?.EVENT,
        facility_id: value,
        month_date: today,
        start_date: start_date,
        end_date: end_date
      }
      dispatch(globalKeyStore({ startValue: new Date(today) }))
      if (eventpayload?.facility_id !== null) {
        // console.log('default API hit')
        delete eventpayload.month_date
        // console.log(currMonthLoc, 'currMonthLoc')
        dispatch(getFilteredEventList(eventpayload)).then((res) => {
          setTimeout(() => {
            firstLoad.current = firstLoad.current + 1
          }, 100)
          const filterEvents = currentMonthFull ? res?.data?.[moment(currentMonthFull).format('MMM-YYYY')] : (changeFac && currMonthLoc && currMonth == '') ? res?.data?.[currMonthLoc] : res?.data?.[currentSelDate] ? res?.data?.[currentSelDate] : []
          const EventsDates = res?.data?.eventsByMonth ? res?.data?.eventsByMonth : []
          const EventsData = []
          for (const property in res?.data) {
            if (property != 'eventsByMonth') {
              EventsData.push(res?.data[property])
            }
          }
          // console.log(filterEvents, 'EventsData')
          dispatch(globalKeyStore({ selectedPassType: 0, eventData: filterEvents, selectEventType: 'event', selectedFacilityId: value, allEventsData: EventsData.flat(), rawEventsData: firstVal ? res?.data : null, calendarDates: EventsDates }))
          getfacilityCenter()
          if (firstVal) {
            setTimeout(() => {
              dispatch(globalKeyStore({ changesForMonth: true }))
            }, 200)
          }
        })

        // time zone start faclity time zone save
        const filterData = partnerDetails?.facilities?.filter((item) => (Number(item?.id) == Number(value) || item?.short_name?.toLowerCase() == getLowercaseValue(value)))
        localStorage.setItem('facilitiesTimezone', filterData?.[0]?.timezone ? filterData?.[0]?.timezone : 'America/New_York')
        dispatch(globalKeyStore({ facilitiesTimezone: filterData?.[0]?.timezone ? filterData?.[0]?.timezone : 'America/New_York' }))

        // time zone end 
      } else {
        navigate(0)
      }
    } else {
      localStorage.removeItem('selectedFacilityId')
      dispatch(globalKeyStore({ selectedFacilityId: null }))
    }
  }


  // API CALL FOR FILTERING THE EVENTS 
  const handleSelectingDate = (date) => {
    if (!festiveEventsFacilities?.includes(Number(facility))) {
      dispatch(globalKeyStore({ selectedYearForLabel: date }))
    }
    //
    const eventType = localStorage.getItem('pass_type_slug')
    const localFacilityId = JSON.parse(localStorage.getItem('selectedFacilityId'))
    const currentSelDate = moment(date)?.format('MMM-YYYY')
    const payload = {
      'event_type': ((eventType) && eventType !== undefined && eventType !== null) ? eventType : 'event',
      'facility_id': localFacilityId,
      // 'month_date': date,
      'start_date': date,
      'end_date': date,
      'pass_id': (selectedPassType) ? selectedPassType : ''
    }
    dispatch(globalKeyStore({ startValue: new Date(date) }))
    dispatch(getFilteredEventList(payload)).then((res) => {
      if (res?.data !== null) {
        if (payload?.event_type == 'event') {
          localStorage?.setItem('selectEventType', 'event')
          localStorage.removeItem('pass_type_slug')
          const filterEvents = res?.data?.[currentSelDate] ? res?.data?.[currentSelDate] : []
          const EventsDates = res?.data?.eventsByMonth ? res?.data?.eventsByMonth : []
          dispatch(globalKeyStore({ selectedPassType: 0, allEventsData: filterEvents, eventData: filterEvents, selectEventType: 'event', selectedFacilityId: localFacilityId, rawEventsData: null, calendarDates: EventsDates }))
        } else {
          localStorage.setItem('passData', JSON.stringify(res?.data))
          localStorage?.setItem('pass_type_slug', res?.data?.pass_type_slug)
          dispatch(globalKeyStore({ passData: res?.data, selectEventType: 'pass' }))
        }
      } else {
        notify('error', res?.errors?.message ? res?.errors?.message : 'No event found!')
        localStorage.setItem('passData', JSON.stringify({}))
        dispatch(globalKeyStore({ selectedPassType: 0, eventData: [], allEventsData: [], selectEventType: 'event', selectedFacilityId: localFacilityId, calendarDates: [] }))
      }
    })
  }
  // END OF API CALL

  const handleListGridView = (value) => {
    dispatch(globalKeyStore({ eventViewStyle: value }))
  }

  const getMonth = () => {
    return moment(selectedYearForLabel, 'YYYY-MM-DD')?.format('MMMM	YYYY')
  }

  const getfacilityCenter = () => {
    const container = document.querySelector('.wrapScroller')
    const activeDiv = document.querySelector('.btn-check[type="radio"]:checked')
    if (container && activeDiv) {
      container.scrollTo({
        left: activeDiv.offsetLeft,
        behavior: 'smooth'
      })
    }
  }

  return (
    (loader) ? <div className='d-flex align-content-center flex-wrap vh-100 justify-content-center'><Loader /></div> : <div>
      <Banner />
      <div className="container mt-5">
        <div className="row mb-3 align-items-end" id="filters">
          <div className="col-sm col-12 order-0 ">
            <h4 className="fw-bold  h2 mb-0">Latest Event in <span className="text-primary">{`"${getMonth()}"`}</span></h4>
          </div>

          {(selectedFacilityId) && <div className="col my-sm-0">
            <div className="ul-list d-none d-sm-block">
              <ul className="nav justify-content-end nav-underline">
                {[...[{ description: 'All Events', id: 0 }], ...passDetails]?.map((item, index) => <li className="nav-item" key={index}>
                  <span className={item?.id == selectedPassType ? 'nav-link active' : 'nav-link'} value={item?.id} id={item?.id} aria-current="page" onClick={() => handlePassManu(item?.id)}>{item?.description}</span>
                </li>
                )}
              </ul>
            </div>

            <select name="" className="form-select mt-3  d-block d-sm-none" aria-label="Default select example" onChange={(e) => handlePassManu(e.target.value)}>
              {[...[{ description: 'All Events', id: 0 }], ...passDetails]?.map((item, index) => <option style={{ overflow: 'ellipsis' }} value={item?.id} selected={item?.id == selectedPassType ? true : false} key={index} >{item?.description}</option>)}
            </select>
          </div>}
          {(selectedFacilityId) && <div className="col-auto">
            <div className="d-sm-block">
              <div className="btn-group">
                <button className={(eventViewStyle == 'list') ? 'btn btn-dark' : 'btn btn-outline-dark'} type='button' value='list' onClick={() => handleListGridView('list')}><i className="fa-solid fa-list"></i></button>
                <button className={(eventViewStyle == 'Grid') ? 'btn btn-dark' : 'btn btn-outline-dark'} type='button' value='Grid' onClick={() => handleListGridView('Grid')}> <i className="fa-solid fa-grip"></i></button>
              </div>
              {/* <button type='button' className="btn btn-outline-primary" onClick={() => handleOffCanvas()}> <i className="fa-solid fa-filter"></i></button> */}
            </div>
            {/* <div className=" d-block d-sm-none ">
              <button type='button' className="btn btn-outline-primary" onClick={() => handleOffCanvas()}> <i className="fa-solid fa-filter"></i></button>
            </div> */}
          </div>}
        </div>

        {/* as per Hemant sir guidensess calender is comented  */}
        <div className="border-top border-bottom py-3">
          <Calender firstLoad={firstLoad} handleSelectingDate={handleSelectingDate} handleFaciltyChange={handleFaciltyChange} setCurrMonthLoc={setCurrMonthLoc} />
        </div>

        {/* for the Selection of the facilities */}
        <div className="py-3 border-bottom">
          <div className="row align-items-center">
            {(facilities?.length > 1) && <div className="col-sm-auto col-6 order-0">
              <h4 className="fw-bold text-primary">Choose Facility</h4>
            </div>}

            <div className="col-sm col-12 order-3 order-sm-1 facilitySelector" action="#">
              <div className="text-left wrapScroller" role="group" aria-label="Basic radio toggle" >
                {/* <input type="radio" className="btn-check" name="facility" value={0} onChange={(e) => handleFaciltyChange(e.target?.value)} id='facility1' checked={!selectedFacilityId ? true : false} defaultChecked />
                          <label className="btn p-3 btn-outline-primary mx-2" htmlFor='facility1'>
                              <b className="mb-0 fw-bold" > <i className="fa fa-map-marker me-2" aria-hidden="true"></i> All Facility</b>
                          </label> */}
                {(facilities)?.map((item, index) => {
                  return (
                    <>
                      <input type="radio" className="btn-check" name="facility" id={`facility${index + 2}`} value={item?.id} onChange={(e) => handleFaciltyChange(e.target?.value, '', '', true)} checked={item?.id == selectedFacilityId ? true : false} />
                      <label className="btn p-3 btn-outline-primary mx-2 mb-0" htmlFor={`facility${index + 2}`}>
                        <b className="mb-0 fw-bold" > <i className="fa fa-map-marker me-2" aria-hidden="true"></i> {item?.full_name}</b>
                      </label>
                    </>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
        {(isLoadingEvent) ? <Loader /> : <div>
          {selectedPassType == 0 && (selectedFacilityId) ?
            <div className={(eventViewStyle == 'list') ? 'row row-cols-1 g-4 mt-0 col-cols-sm-2' : 'row row-cols-2 g-4 mt-0 col-cols-sm-2'}>
              <BookingList isMainScreen firstLoad={firstLoad} notify={notify} selectedFacilityId={selectedFacilityId} />
            </div> :
            (selectedFacilityId) ?
              <MultipleEventCrousel isMainScreen hidePaymentDetails eventViewStyle={eventViewStyle} /> : null
          }
        </div>}

        <div className=" my-4 d-block text-center">
          {(selectedPassType == 0 && eventData?.length > 4) ? <button className="btn btn-secondary px-5" onClick={() => loadMore()}><i className="fa fa-refresh"></i> More Events</button> : null}
        </div>
      </div>
      <OffCanvas />
    </div >
  )
}

Main.propTypes = {
  dispatch: PropTypes.func,
  notify: PropTypes.func,
  globalData: PropTypes.object,
  selectedPassType: PropTypes.number,
  noOfEventShow: PropTypes.number,
  isCanvasShow: PropTypes.bool,
  startDate: PropTypes.string,
  passDetails: PropTypes.array,
  loader: PropTypes.bool,
  eventData: PropTypes.array,
  partnerDetails: PropTypes.object,
  selectedFacilityId: PropTypes.string,
  selectedYearForLabel: PropTypes.string,
  isLoadingEvent: PropTypes.bool,
  eventViewStyle: PropTypes.string
}

Main.defaulProps = {
  dispatch: noop,
  globalData: EMPTY_OBJECT,
  notify: noop,
  selectedPassType: '',
  noOfEventShow: 4,
  isCanvasShow: false,
  startDate: new Date(),
  passDetails: EMPTY_ARRAY,
  loader: false,
  eventData: EMPTY_ARRAY,
  partnerDetails: EMPTY_OBJECT,
  selectedFacilityId: '',
  selectedYearForLabel: moment(new Date()).format('YYYY-MM-DD'),
  isLoadingEvent: false,
  eventViewStyle: ''
}

function mapStateToProps({ globalReducers, mainReducer }) {
  return {
    selectedPassType: globalReducers?.selectedPassType,
    noOfEventShow: globalReducers?.noOfEventShow,
    isCanvasShow: globalReducers?.isCanvasShow,
    startDate: globalReducers?.startValue,
    passDetails: mainReducer?.passDetails,
    loader: mainReducer?.loader,
    eventData: globalReducers?.eventData,
    partnerDetails: globalReducers?.partnerDetails,
    selectedFacilityId: globalReducers?.selectedFacilityId,
    selectedYearForLabel: globalReducers?.selectedYearForLabel,
    isLoadingEvent: mainReducer?.isloader,
    eventViewStyle: globalReducers?.eventViewStyle
  }
}

export default connect(mapStateToProps)(Main)